import api from "../axios";

export interface Article {
  nm_id: number;
  name: string;
  photo_url: string | null;
}

export interface NmsItem {
  nm_id: number;
  name: string;
  photo_url: string | null;
}

export interface NmsResponse {
  data: NmsItem[];
  total: number;
  is_partial: boolean;
}

export class ApiTable {
  getServiceAccount() {
    return api.get<{
      client_id: string;
      email: string;
    }>("/tables/service-accounts/new");
  }

  checkTableAccess(clientId: string, tableId: string) {
    return api.get<{
      has_access: boolean;
    }>("/tables/check-access", {
      params: { client_id: clientId, table_id: tableId },
    });
  }

  createAutoTable(data: {
    table_id: string;
    client_id: string;
    supplier_id: string;
  }) {
    return api.post<{
      table_id: string;
    }>("/tables/auto", data);
  }

  createJamTable(data: {
    table_id: string;
    client_id: string;
    supplier_id: string;
    nms: number[];
  }) {
    return api.post<{
      table_id: string;
    }>("/tables/jam", data);
  }

  deleteTable(tableId: string) {
    return api.delete(`/tables/${tableId}`);
  }

  unsubscribeTable(tableId: string) {
    return api.post(`/tables/unsubscribe/${tableId}`);
  }

  getTableStatus(tableId: string) {
    return api.get<{
      id: string;
      user_id: string;
      supplier_id: string;
      table_type: string;
      subscription_type: "free" | "paid" | "disabled";
      created_at: string;
      expires_at: string;
    }>(`/tables/${tableId}`);
  }

  getNms(
    supplierId: string,
    params?: {
      q?: string | null;
      limit?: number;
      offset?: number;
    },
  ) {
    return api.get<NmsResponse>(`/tables/nms/${supplierId}/all`, { params });
  }

  getUsedNms(supplierId: string) {
    return api.get<{ data: number[] }>(`/tables/nms/${supplierId}/used`);
  }

  setNms(data: { table_id: string; nms: number[] }) {
    return api.post(`/tables/nms`, data);
  }
}
